export default __webpack_public_path__ + "static/media/CounterLeftImage.3a070796.png";